import { Team } from '@/app/entities/Team'
import { httpClient } from '../http/httpClient'

export async function getDefaultTeam() {
  const { data } = await httpClient.get<Team>('/config/team')

  return data
}
